import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

export const LightTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: "rgba(60,184,121,1)",
		color: "rgba(255,255,255,1)",
		boxShadow: theme.shadows[1],
		fontSize: 16,
	},
}));
